export default __webpack_public_path__ + "static/media/erik_fisher.7efae076.png";